import { render, staticRenderFns } from "./auditStatistics.vue?vue&type=template&id=24241e33&scoped=true&"
import script from "./auditStatistics.vue?vue&type=script&lang=js&"
export * from "./auditStatistics.vue?vue&type=script&lang=js&"
import style0 from "./auditStatistics.vue?vue&type=style&index=0&id=24241e33&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24241e33",
  null
  
)

export default component.exports